module.exports = require("./lkt.d.ts");